import React from "react";
import i18n from "../../../i18n/config";

const CardDetailsLearnMore = () => {
  return (
    <>
      <p>{i18n.t("PAGES.DASHBOARD.SHOW_CARD_DETAILS_MODAL.P1")}</p>
      <p className="spacing-bottom-none">{i18n.t("PAGES.DASHBOARD.SHOW_CARD_DETAILS_MODAL.P2")}</p>
      <ol>
        <li>{i18n.t("PAGES.DASHBOARD.SHOW_CARD_DETAILS_MODAL.LI1_1")} <span className="bold">{i18n.t("PAGES.DASHBOARD.SHOW_CARD_DETAILS_MODAL.LI1_2")}</span></li>
        <li>{i18n.t("PAGES.DASHBOARD.SHOW_CARD_DETAILS_MODAL.LI2_1")} <span className="bold">{i18n.t("PAGES.DASHBOARD.SHOW_CARD_DETAILS_MODAL.LI2_2")}</span></li>
        <li>{i18n.t("PAGES.DASHBOARD.SHOW_CARD_DETAILS_MODAL.LI3")}</li>
      </ol>
    </>
  );
}

export default CardDetailsLearnMore;